const PurchasedBodyModelView = require("./containers/PurchasedBodyModelView");
const Authenticate = require("../utils").authenticate;

// Sync route definition
module.exports = {
    path: "/purchased-body-model/:id",
    component: Authenticate(PurchasedBodyModelView),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/purchased-body-model-view/index.js